import { render } from "./Pledges.vue?vue&type=template&id=cd532588"
import script from "./Pledges.vue?vue&type=script&lang=js"
export * from "./Pledges.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__